import type { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../core-components/theme/components/Buttons';
import { Sheet } from '../../../../core-components/theme/components/Sheet';
import type { AlertsStillCome } from '../../hooks/push/usePushPermissionAsk';

const stillComesText = (t: TFunction, stillComes: AlertsStillCome): string => {
  switch (stillComes) {
    case 'WHATSAPP':
      return t('closeTheLoop.push.stillWhatsapp', 'Your WhatsApp alerts still come.');
    case 'SMS':
      return t('closeTheLoop.push.stillSms', 'Your SMS alerts still come.');
    case 'APP':
      return t('closeTheLoop.push.stillApp', 'Your alerts still show in the app.');
  }
};

export interface PushPermissionDialogProps {
  readonly open: boolean;
  readonly stillComes: AlertsStillCome;
  readonly onAllow: () => void;
  readonly onNotNow: () => void;
}

export const PushPermissionDialog: React.FC<PushPermissionDialogProps> = ({ open, stillComes, onAllow, onNotNow }) => {
  const { t } = useTranslation();
  const body = t('closeTheLoop.push.askBody', 'DigitalPaani will show a notification for every alert, even when the app is closed.');
  return (
    <Sheet
      open={open}
      onClose={onNotNow}
      title={t('closeTheLoop.push.askTitle', 'Show alerts on this phone?')}
      description={`${body} ${stillComesText(t, stillComes)}`}
      secondary={
        <Button type="button" intent="secondary" onClick={onNotNow}>
          {t('closeTheLoop.push.notNow', 'Not now')}
        </Button>
      }
      primary={
        <Button type="button" intent="primary" onClick={onAllow}>
          {t('closeTheLoop.push.allow', 'Allow')}
        </Button>
      }
    />
  );
};
